import { atom } from 'jotai';
import { Consent } from 'shared/data/webApp/v1';

export const bankingAppLoginPopupState = atom<
    Partial<Omit<Consent, 'id' | 'createdAt'>> & { consentId?: string; bankId?: string; createdAt?: Date }
>({});
